import { Config } from "../../Config";
import { eventBus } from "../EventBus";
import { Notification } from "../../Components/Notifications";

export const ALLOWED_DOCUMENT_MIME_TYPES = [
  "application/pdf",
  "text/plain",
  "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
];

// Validates newly selected files (type, size) against Config's upload limits,
// combines them with whatever was already pending, and caps the total at
// Config.MAX_UPLOAD_FILES. Emits a notification for each rejected or
// capped file — the caller only needs to render whatever list comes back.
export const combineAttachedFiles = (newFiles: File[], existingFiles: File[]): File[] => {
  const validFiles: File[] = [];
  const maxSizeBytes = Config.MAX_UPLOAD_SIZE_MB * 1024 * 1024;

  for (const file of newFiles) {
    if (!ALLOWED_DOCUMENT_MIME_TYPES.includes(file.type)) {
      eventBus.emit(
        "NOTIFICATION",
        Notification.buildNotification("error", `Tipo de archivo no soportado: ${file.name}. Usa PDF, TXT o DOCX.`)
      );
      continue;
    }
    if (file.size > maxSizeBytes) {
      eventBus.emit(
        "NOTIFICATION",
        Notification.buildNotification("error", `${file.name} excede el límite de ${Config.MAX_UPLOAD_SIZE_MB} MB.`)
      );
      continue;
    }
    validFiles.push(file);
  }

  if (validFiles.length === 0) return existingFiles;

  const combined = [...existingFiles, ...validFiles];
  if (combined.length > Config.MAX_UPLOAD_FILES) {
    eventBus.emit(
      "NOTIFICATION",
      Notification.buildNotification("error", `Solo puedes adjuntar hasta ${Config.MAX_UPLOAD_FILES} documentos a la vez.`)
    );
    return combined.slice(0, Config.MAX_UPLOAD_FILES);
  }
  return combined;
};
